import type { ActionCodeSettings } from 'firebase/auth';

const DEFAULT_APP_URL = 'https://app.kulum.jp';
const AUTH_ACTION_PATH = '/auth/action';
type AuthActionMode = 'verifyEmail' | 'verifyAndChangeEmail' | 'resetPassword';

function getAppBaseUrl(): string {
  const envAppUrl = import.meta.env.VITE_APP_URL?.trim();
  if (envAppUrl) {
    return envAppUrl;
  }

  if (typeof window !== 'undefined') {
    return window.location.origin;
  }

  return DEFAULT_APP_URL;
}

export function getAuthActionCodeSettings(mode?: AuthActionMode): ActionCodeSettings {
  const actionUrl = new URL(AUTH_ACTION_PATH, `${getAppBaseUrl().replace(/\/$/, '')}/`);
  if (mode) {
    actionUrl.searchParams.set('mode', mode);
  }
  return { url: actionUrl.toString() };
}
